module.exports = __webpack_public_path__ + "static/media/marketing.4104fb4a.svg";